/*
 * @Author: Haotian Zheng
 * @Date: 2023-07-27 09:49:05
 * @Descripttion:
 * @LastEditors: Haotian Zheng
 * @LastEditTime: 2023-07-27 10:58:21
 */
import axios from './http'
import base from './base'

// post 查询内容list
export function findNoticeMessageList(data) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/noticeMessage/findNoticeMessageList`,
    method: 'post',
    data: data,
  })
}
//根据id获取内容详情
export function getNoticeMessageById(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/noticeMessage/getNoticeMessage`,
    method: 'get',
    params,
  })
}
//查询有几条未读信息
export function getNoReadMessageCount(params) {
  return axios({
    url: `${base.url}/jishuiyun-tenant/noticeMessage/getNoReadMessageCount`,
    method: 'get',
    params,
  })
}
